module.exports = __webpack_public_path__ + "static/media/CivilPro.e3008f80.png";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/CivilPro.png
// module id = 1727
// module chunks = 1